import { render, staticRenderFns } from "./vote.vue?vue&type=template&id=540518bd&scoped=true&"
import script from "./vote.vue?vue&type=script&lang=js&"
export * from "./vote.vue?vue&type=script&lang=js&"
import style0 from "./vote.vue?vue&type=style&index=0&id=540518bd&prod&lang=less&scoped=true&"
import style1 from "./vote.vue?vue&type=style&index=1&id=540518bd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540518bd",
  null
  
)

export default component.exports